module.exports = __webpack_public_path__ + "img/c03_unitcaravan_Normal_ua.84904de2.webp";